<template>
    <div class="TopicAnswer">
        <Popup @closed="closedAnswer" :value="value" position="bottom" :overlay="true" @click-overlay="$emit('input', false)">
            <div class="directory">
                <div class="directory-top">
                    <div class="name">查看答案</div>
                    <div class="topic-number">
                        <span class="index" :class="{active:i === activeIndex }" v-for="(item,i) in T.index" @click="activeIndex = i">{{ item }}题</span>
                    </div>
                    <div class="close" @click="$emit('input', false)">
                        <img src="../../assets/img/close.png" alt="">
                    </div>
                </div>
                <div class="content" v-if="T.type == 1 || T.type == 2">
                    <div class="correct-answer">正确答案：{{ T.answer.map(r=>LetterArr[r]).join('') }}</div>
                    <div class="answer-name">试题解析</div>
<!--                    <div class="analysis rich-text" ref="analyzeText" @touchstart="touchstart" @touchend="touchend">-->
                    <div class="analysis rich-text">
                        <div v-html="T.answerContentHtml || T.answerContent"></div>
                    </div>
                    <div class="back-btn" @click="$emit('input', false)">返回</div>
                </div>
                <div class="content" v-else>
                    <div class="correct-answer">正确答案：{{ T.sonQuestion[activeIndex].answer.map(r=>LetterArr[r]).join('') }}</div>
                    <div class="answer-name">试题解析</div>
                    <div class="analysis rich-text">
                        <div v-if="T.answerContentHtml || T.answerContent" v-html="T.answerContentHtml || T.answerContent"></div>
                        <div v-if="T.sonQuestion[activeIndex].answerContentHtml || T.sonQuestion[activeIndex].answerContent" 
                             v-html="T.sonQuestion[activeIndex].answerContentHtml || T.sonQuestion[activeIndex].answerContent"></div>
                    </div>
                    <div class="back-btn" @click="$emit('input', false)">返回</div>
                </div>
            </div>
          <slot></slot>
        </Popup>
    </div>
</template>
<script>
    import {Popup} from 'vant';
    import {LetterArr} from '@/utils/topic.js'
    // const isMoveDistanceVal = (document.documentElement.clientHeight/8);

    export default {
        name: 'TopicAnswer',
        props: {
            value:Boolean,
            T: { //当前大题对象
                type:Object,
                default:function () {
                    return {}
                }
            },
        },
        data: function () {
            return {
                activeIndex:0,
                LetterArr:LetterArr,
                // touchstartY:0,
            }
        },
        methods: {
            closedAnswer(){
                this.activeIndex = 0
            },
            // touchstart(e){
            //     this.touchstartY = e.changedTouches[0].clientY;
            // },
            // touchend(e){
            //     let endClientY = e.changedTouches[0].clientY;
            //     if((this.touchstartY < endClientY) && (endClientY - this.touchstartY) > isMoveDistanceVal){
            //         this.$emit('input', false)
            //     }
            // },
            // openedPopup(){
            //     let analyze = this.$refs['analyzeText'];
            //     console.log(analyze);
            //     analyze.onscroll = ()=>{
            //         if(analyze.scrollTop !== 0){
            //             this.touchstartY = document.documentElement.clientHeight
            //         }
            //     };
            //
            // }
        },
        components: {Popup},
        mounted() {
          console.log('TopicAnswer 更新');
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .TopicAnswer {
        .directory{
            height: 100vh;
            padding: 0 16px;
            background: #fff;
            display: flex;
            flex-direction: column;
            .directory-top{
                display: flex;
                width: 100%;
                height: 52px;
                justify-content: space-between;
                align-items: center;
                .close {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    padding: 5px;
                    img{
                        width: 12px;
                        height: 12px;
                    }
                }
                .topic-number{
                    flex: 1;
                    margin: 0 10px;
                    overflow-y: hidden;
                    overflow-x: auto;
                    white-space: nowrap;
                    display: inline-block;
                    border-radius:2px;
                    .index{
                        font-size: 13px;
                        color: #5F6F8B;
                        padding: 4px 6px;
                        background: #F3F5F9;
                        margin-right: 10px;
                        &.active{
                            background: #fff6f5;
                            color: #F84025;
                        }
                    }
                }
                .name{
                    font-size:15px;
                    color: #222;
                }
            }
            .content{
                display: flex;
                flex-direction: column;
                flex: 1;
                height: calc(100vh - 52px); //兼容OPPO R17 手机对flex: 1无效问题
                .analysis{
                    padding: 13px 0;
                    flex: 1;
                    overflow-y: auto;
                    &>div {
                        width: 100%;
                    }
                    video {
                        width: 100%;
                    }
                    audio {
                        width: 100%;
                    }
                    img {
                        width: 100%;
                    }
                }
                .rich-text {
                  line-height: normal !important;
                }
                .correct-answer{
                    display: flex;
                    width: 100%;
                    height: 50px;
                    align-items: center;
                    padding: 0 14px;
                    font-size:16px;
                    color: #222;
                    background: #FFF6F5;
                }
                .answer-name{
                    display: flex;
                    width: 100%;
                    height: 60px;
                    align-items: center;
                    font-size:15px;
                    color: #222;
                    border-bottom: 1px solid #F3F5F9;
                }
                .back-btn{
                    display: flex;
                    width: 100%;
                    height: 50px;
                    justify-content: center;
                    align-items: center;
                    font-size:15px;
                    color: #F84025;
                    border-top: 1px solid #F3F5F9;
                }

            }
        }

    }
</style>
